import { createContext, useReducer } from "react";

export const TokenErrorContext = createContext();

export const tokenErrorReducer = (state, action) => {
    switch (action.type) {
        case 'SET_TOKEN_ERROR':
            return {
                tokenError: action.payload
            }
        case 'CREATE_TOKEN_ERROR':
            return {
                tokenError: true
            }
        case 'DELETE_TOKEN_ERROR':
            return {
                tokenError: null
            }
        default:
            return state
    };
};

export const TokenErrorContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(tokenErrorReducer, {
        tokenError: null
    });

    return (
        <TokenErrorContext.Provider value={{ ...state, dispatch }}>
            {children}
        </TokenErrorContext.Provider>
    );
};